import { useDispatch, useSelector } from "react-redux";

import { useState, useEffect, useRef } from "react";

import {
  closeMobileMenu,
  setCurrentPath,
  toggleMobileMenu,
} from "../features/navigation/navigationSlice";

import {
  fetchNotifications,
  updateNotifications,
} from "../features/admin/NotificationSlice";

import { fetchCategoryByTypePublic } from "../features/admin/CategorySlice";

import { Link, useNavigate, useLocation } from "react-router-dom";

import { UserCircleIcon } from "@heroicons/react/16/solid";

import { BellIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { toast } from "react-toastify";

/* ===================== SearchBar ===================== */

/* - Nhận prop isMemberSearchAllowed để ẩn "Hội viên" khi chưa đăng nhập

- Hiển thị responsive đẹp trên mobile (stack dọc), desktop (nằm ngang)

*/

function SearchBar({ show, onSearch, isMemberSearchAllowed }) {
  const [keyword, setKeyword] = useState("");

  const [type, setType] = useState(
    isMemberSearchAllowed ? "hoi-vien" : "san-pham",
  );

  const inputRef = useRef();

  useEffect(() => {
    // Nếu đang chọn "hoi-vien" mà không được phép (chưa login) -> ép sang "san-pham"

    if (!isMemberSearchAllowed && type === "hoi-vien") {
      setType("san-pham");
    }
  }, [isMemberSearchAllowed, type]);

  useEffect(() => {
    if (show) inputRef.current?.focus();
  }, [show]);

  if (!show) return null;

  return (
    <div className="w-full bg-gradient-to-r from-[#003866] to-[#1179c6] py-4 sm:py-6 lg:py-8 z-20 relative">
      <form
        className="w-full max-w-[1580px] mx-auto px-3 sm:px-4"
        onSubmit={(e) => {
          e.preventDefault();

          onSearch?.({ keyword, type });
        }}
      >
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 items-stretch sm:items-center w-full">
          <div className="flex items-center bg-white rounded-lg shadow px-3 h-11 sm:h-12 min-w-0 flex-1">
            <MagnifyingGlassIcon className="w-5 h-5 text-gray-400 mr-2" />

            <input
              ref={inputRef}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              placeholder="Nội dung tìm kiếm..."
              className="flex-1 bg-transparent outline-none border-none min-h-12 text-gray-700 text-base placeholder-gray-400"
            />
          </div>

          <select
            className="h-11 sm:h-12 min-w-[160px] sm:min-w-[180px] rounded-lg shadow bg-white px-3 text-base text-gray-700"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            {isMemberSearchAllowed && (
              <option value="hoi-vien">Hội viên</option>
            )}

            <option value="san-pham">Sản phẩm hội viên</option>
          </select>

          <button
            type="submit"
            className="h-11 sm:h-12 flex items-center justify-center px-5 rounded-lg bg-[#02aaff] hover:bg-[#0099da] text-white font-bold shadow transition text-base"
          >
            <MagnifyingGlassIcon className="w-5 h-5 mr-1" />
            Tìm kiếm
          </button>
        </div>
      </form>
    </div>
  );
}

/* ===================== Header ===================== */

export default function Header() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [userFullName, setUserFullName] = useState("");

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const [isShowSearch, setIsShowSearch] = useState(false);

  const [isMobileNotificationOpen, setIsMobileNotificationOpen] =
    useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  const { navbars } = useSelector((state) => state.categories);

  const { notifications, status } = useSelector((state) => state.notifications);

  const { posts } = useSelector((state) => state.posts);

  const logo = useSelector((state) => state.logo.logo);

  const dispatch = useDispatch();

  const { isMobileMenuOpen } = useSelector((state) => state.navigation);

  /* ----------- RULE 2: Trang danh sách thì không cho toggle ẩn search ----------- */

  const isSearchStickyPage =
    location.pathname.startsWith("/danh-sach-hoi-vien") ||
    location.pathname.startsWith("/danh-sach-san-pham");

  useEffect(() => {
    dispatch(
      fetchCategoryByTypePublic(
        "navbar,notification,training_recruitment,practice_certificate,legal_document,cadoor",
      ),
    );
  }, [dispatch]);

  useEffect(() => {
    localStorage.setItem("searchQuery", "");

    if (isMobileMenuOpen) {
      dispatch(toggleMobileMenu());
    }

    // Bật thanh tìm kiếm cố định nếu đang ở trang danh sách

    if (isSearchStickyPage) {
      setIsShowSearch(true);
    }
  }, [location.pathname]); // eslint-disable-line

  useEffect(() => {
    const fullName = localStorage.getItem("full_name");

    if (fullName) {
      setIsLoggedIn(true);

      setUserFullName(fullName);
    } else {
      setIsLoggedIn(false);

      setUserFullName("");
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token_bccu");

    localStorage.removeItem("permissions");

    localStorage.removeItem("full_name");

    localStorage.removeItem("type_user");

    localStorage.removeItem("userId");

    localStorage.removeItem("companyId");

    localStorage.removeItem("userPhone");

    localStorage.removeItem("userEmail");

    localStorage.setItem("cart", JSON.stringify([]));

    setIsLoggedIn(false);

    setUserFullName("");

    setIsUserMenuOpen(false);

    navigate("/");

    window.location.reload();
  };

  const jumpToRegister = () => {
    const hash = "#dang-ky";

    if (location.pathname !== "/") {
      navigate(`/${hash}`);

      return;
    }

    if (window.location.hash === hash) {
      window.history.replaceState(null, null, " ");

      setTimeout(() => {
        window.location.hash = hash;
      }, 0);
    } else {
      window.location.hash = hash;
    }
  };

  const isActivePath = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }

    if (path === "/gioi-thieu") {
      return (
        location.pathname === "/gioi-thieu" ||
        location.pathname.startsWith("/gioi-thieu/")
      );
    }

    if (path === "/hoat-dong") {
      return (
        location.pathname === "/hoat-dong" ||
        location.pathname.startsWith("/hoat-dong/")
      );
    }

    if (path === "/dao-tao-tuyen-dung") {
      return (
        location.pathname === "/dao-tao-tuyen-dung" ||
        location.pathname.startsWith("/dao-tao-tuyen-dung/")
      );
    }

    if (path === "/cap-chung-chi-hanh-nghe") {
      return (
        location.pathname === "/cap-chung-chi-hanh-nghe" ||
        location.pathname.startsWith("/cap-chung-chi-hanh-nghe/")
      );
    }

    if (path === "/van-ban-phap-luat") {
      return (
        location.pathname === "/van-ban-phap-luat" ||
        location.pathname.startsWith("/van-ban-phap-luat/")
      );
    }

    if (path === "/chi-hoi-nganh-cua") {
      return (
        location.pathname === "/chi-hoi-nganh-cua" ||
        location.pathname.startsWith("/chi-hoi-nganh-cua/")
      );
    }

    if (path === "/thong-bao") {
      return (
        location.pathname === "/thong-bao" ||
        location.pathname.startsWith("/thong-bao/") ||
        location.pathname === "/image" ||
        location.pathname === "/video"
      );
    }

    return location.pathname === path;
  };

  const navItems = [
    {
      path: "/",

      label: <img src={logo} alt="Logo" className="h-16 object-cover" />,
    },

    {
      path: "/gioi-thieu/qua-trinh-hinh-thanh-va-phat-trien",

      activePath: "/gioi-thieu",

      label: "Giới thiệu",

      subMenu: [
        {
          path: "/gioi-thieu/qua-trinh-hinh-thanh-va-phat-trien",

          label: "Quá trình hình thành và phát triển",
        },

        {
          path: "/gioi-thieu/thu-ngo-cua-chu-tich-hoi",

          label: "Thư ngỏ của Chủ tịch Hội",
        },

        {
          path: "/gioi-thieu/co-cau-to-chuc",

          label: "Cơ cấu tổ chức",
        },

        {
          path: "/gioi-thieu/dieu-le-hoi",

          label: "Điều lệ Hội",
        },

        {
          path: "/gioi-thieu/quy-che-hoat-dong-cua-hoi",

          label: "Quy chế hoạt động của Hội",
        },

        {
          path: "/gioi-thieu/quy-che-hoat-dong-ban-chap-hanh",

          label: "Quy chế hoạt động Ban chấp hành",
        },

        {
          path: "/gioi-thieu/quy-che-chi-tieu-noi-bo",

          label: "Quy chế chi tiêu nội bộ",
        },
      ],
    },

    {
      path: "/hoat-dong",

      label: "Hoạt động",

      subMenu: navbars

        ?.filter((e) => e.type === "navbar")

        ?.map((item) => ({
          ...item,

          path: `/hoat-dong/${item.slug}`,

          label: item.name,
        })),
    },

    {
      path: "/dao-tao-tuyen-dung",

      label: "Đào tạo & tuyển dụng",

      subMenu:
        navbars

          ?.filter((e) => e.type === "training_recruitment")

          ?.map((item) => ({
            ...item,

            path: `/dao-tao-tuyen-dung/${item.slug}`,

            label: item.name,
          })) || [],
    },

    {
      path: "/cap-chung-chi-hanh-nghe",

      label: "Cấp chứng chỉ",

      subMenu: navbars

        ?.filter((e) => e.type === "practice_certificate")

        ?.map((item) => ({
          ...item,

          path: `/cap-chung-chi-hanh-nghe/${item.slug}`,

          label: item.name,
        })),
    },

    {
      path: "/hoi-vien",

      label: "Hội viên",

      subMenu: [
        {
          path: "/hoi-vien/dang-ky",

          label: "Đăng ký hội viên",

          onClick: jumpToRegister,
        },

        ...(isLoggedIn

          ? [
              {
                path: "/danh-sach-hoi-vien",

                label: "Danh sách hội viên",
              },
            ]

          : []),
      ],
    },

    { path: "/tin-tuc-su-kien", label: "Tin tức" },

    {
      path: "/thong-bao",

      label: "Sự kiện",

      subMenu: [
        { path: "/thong-bao/", label: "Đăng ký hoạt động" },

        { path: "/image", label: "Hình ảnh" },

        { path: "/video", label: "Video" },
      ],
    },

    {
      path: "/van-ban-phap-luat",

      label: "Văn bản pháp luật",

      subMenu: navbars

        ?.filter((e) => e.type === "legal_document")

        ?.map((item) => ({
          ...item,

          path: `/van-ban-phap-luat/${item.slug}`,

          label: item.name,
        })),
    },

    {
      path: "/chi-hoi-nganh-cua",

      label: "Chi hội Cadoor",
    },

    { path: "/lien-he", label: "Liên hệ" },
  ];

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    if (status === "idle" && userId) {
      dispatch(fetchNotifications(userId));
    }
  }, [status, dispatch, userId]);

  const handleReadNotification = async (id) => {
    try {
      await dispatch(updateNotifications(id)).unwrap();
    } catch (error) {
      toast.error("Lỗi khi truy cập thông báo");
    }
  };

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isMobileMenuOpen]);

  const handleUrl = (slug) => {
    const data = posts.find((post) => post.slug === slug);

    if (data?.type === "notification") {
      return "/thong-bao/" + data?.category?.slug + "/" + slug;
    }

    return "/post/" + slug;
  };

  return (
    <>
      <header className="w-full bg-base-100 shadow-md z-30 sticky top-0">
        <div className="container mx-auto max-w-[1580px] flex items-center justify-between px-4 py-2">
          <div className="flex items-center gap-2 flex-shrink-0">
            <Link to="/">
              <img src={logo} alt="Logo" className="h-12 object-contain" />
            </Link>

            <div className="leading-snug">
              <p className="font-bold text-blue-900 text-sm uppercase">
                Hội Xây Dựng
                <br />
                Thành phố Cần Thơ
              </p>
            </div>
          </div>

          {/* Menu desktop */}

          <nav className="hidden lg:flex items-center gap-1 flex-nowrap overflow-visible">
            {navItems.slice(1).map((item) => (
              <div key={item.path} className="relative group flex-shrink-0">
                {item.subMenu?.length > 0 ? (
                  <>
                    <button
                      tabIndex={0}
                      className={`btn btn-ghost font-bold h-12 flex flex-nowrap items-center gap-1 text-xs whitespace-nowrap px-2 ${
                        isActivePath(item.activePath || item.path)
                          ? "text-primary"
                          : "text-black"
                      }`}
                      onClick={() => {
                        navigate(item.path);

                        dispatch(setCurrentPath(item.path));
                      }}
                    >
                      <span className="whitespace-nowrap">{item.label}</span>

                      <svg
                        className="w-4 h-4 ml-1 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>

                    <div className="absolute p-2 left-0 top-11 bg-base-100 shadow-lg rounded-box mt-1 z-50 min-w-[200px] hidden group-hover:block">
                      {item.subMenu.map((subItem) =>
                        subItem.onClick ? (
                          <button
                            key={subItem.path}
                            type="button"
                            className="block w-full text-left px-4 py-2 hover:bg-base-200 text-sm whitespace-nowrap"
                            onClick={() => {
                              subItem.onClick();

                              dispatch(setCurrentPath(subItem.path));
                            }}
                          >
                            {subItem.label}
                          </button>
                        ) : (
                          <Link
                            key={subItem.path}
                            to={subItem.path}
                            className="block px-4 py-2 hover:bg-base-200 text-sm whitespace-nowrap"
                            onClick={() =>
                              dispatch(setCurrentPath(subItem.path))
                            }
                          >
                            {subItem.label}
                          </Link>
                        ),
                      )}
                    </div>
                  </>
                ) : (
                  <Link
                    to={item.path}
                    className={`btn btn-ghost font-bold h-12 flex items-center text-xs whitespace-nowrap px-2 ${
                      isActivePath(item.path) ? "text-primary" : "text-black"
                    }`}
                    onClick={() => dispatch(setCurrentPath(item.path))}
                  >
                    {item.label}
                  </Link>
                )}
              </div>
            ))}

            {/* Notification */}

            {isLoggedIn && (
              <div className="relative group flex items-center ml-1 flex-shrink-0">
                <BellIcon className="w-6 h-6 cursor-pointer text-gray-400" />

                {notifications.filter((n) => n.isRead === "0").length > 0 && (
                  <span className="absolute top-0 right-0 bg-red-500 text-base-300 text-xs font-bold rounded-full px-1">
                    {notifications.filter((n) => n.isRead === "0").length}
                  </span>
                )}

                <div
                  className="absolute p-2 top-full bg-base-100 shadow-lg rounded-lg z-50 w-64 min-w-[200px] hidden group-hover:flex flex-col max-h-96 overflow-y-auto"
                  style={{ right: "-85px" }}
                >
                  {notifications.filter((n) => n.isRead === "0").length ===
                  0 ? (
                    <div className="text-gray-500 text-sm px-4 py-2">
                      Không có thông báo
                    </div>
                  ) : (
                    notifications

                      .filter((n) => n.isRead === "0")

                      .map((notification) => (
                        <Link
                          key={notification.id}
                          to={handleUrl(notification.data)}
                          onClick={() =>
                            handleReadNotification(notification.id)
                          }
                          className="block text-sm p-2 hover:bg-base-200"
                        >
                          <div className="flex justify-between items-center">
                            <span>{notification.content}</span>

                            {notification.isRead === "0" && (
                              <span className="text-blue-500 text-xs">⬤</span>
                            )}
                          </div>
                        </Link>
                      ))
                  )}
                </div>
              </div>
            )}

            {/* User */}

            <div className="relative group flex items-center gap-1 flex-shrink-0">
              {isLoggedIn ? (
                <>
                  <button
                    tabIndex={0}
                    className="btn btn-ghost font-bold h-12 flex items-center gap-1 text-xs whitespace-nowrap px-2"
                    onClick={() => setIsUserMenuOpen((prev) => !prev)}
                  >
                    <UserCircleIcon className="h-5 w-5 text-gray-600 flex-shrink-0" />

                    <span className="truncate max-w-[120px]">
                      {userFullName}
                    </span>

                    <svg
                      className="w-4 h-4 flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {/* Menu con */}

                  {isUserMenuOpen && (
                    <ul className="absolute right-0 top-full mt-1 w-52 menu bg-base-100 shadow-lg rounded-box z-50">
                      <li>
                        <Link
                          to={"/admin"}
                          onClick={() => {
                            setTimeout(() => {
                              window.location.reload();
                            }, 0);
                          }}
                        >
                          Trang quản trị
                        </Link>
                      </li>

                      <li>
                        <button onClick={handleLogout} className="text-error">
                          Đăng xuất
                        </button>
                      </li>
                    </ul>
                  )}
                </>
              ) : (
                <Link
                  to="/login"
                  className="btn btn-ghost font-bold h-12 flex items-center gap-1 text-xs whitespace-nowrap px-2"
                  onClick={() => {
                    dispatch(setCurrentPath("/login"));
                  }}
                >
                  <UserCircleIcon className="h-5 w-5 text-gray-600 flex-shrink-0" />
                  Đăng nhập
                </Link>
              )}
            </div>

            {/* Toggle Search (desktop) — bị vô hiệu trên trang danh sách */}

            <button
              className={`btn btn-ghost p-2 ml-1 flex-shrink-0 ${isSearchStickyPage ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={() => {
                if (!isSearchStickyPage) setIsShowSearch((s) => !s);
              }}
              aria-label="Tìm kiếm"
              title={
                isSearchStickyPage
                  ? "Thanh tìm kiếm luôn hiển thị ở trang này"
                  : "Tìm kiếm"
              }
            >
              <MagnifyingGlassIcon className="w-6 h-6 text-gray-600" />
            </button>
          </nav>

          {/* Mobile buttons (right side): Search toggle + Menu */}

          <div className="lg:hidden flex items-center gap-1">
            {/* Toggle Search (mobile) — vô hiệu ở trang danh sách */}

            <button
              className={`btn btn-ghost p-2 ${isSearchStickyPage ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={() => {
                if (!isSearchStickyPage) setIsShowSearch((s) => !s);
              }}
              aria-label="Tìm kiếm"
              title={
                isSearchStickyPage
                  ? "Thanh tìm kiếm luôn hiển thị ở trang này"
                  : "Tìm kiếm"
              }
            >
              <MagnifyingGlassIcon className="w-6 h-6 text-gray-700" />
            </button>

            <button
              className="btn btn-ghost"
              onClick={() => dispatch(toggleMobileMenu())}
              aria-label="Mở menu"
            >
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}

        <div
          className={`fixed top-0 left-0 h-full w-3/4 bg-base-200 shadow-lg z-50 transform ${
            isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out overflow-y-auto lg:hidden`}
        >
          <div className="absolute top-5 right-10 w-24 z-[100] text-right">
            <button
              className="ml-2 text-2xl"
              onClick={() => dispatch(closeMobileMenu())}
            >
              ✖
            </button>
          </div>

          <ul className="flex flex-col gap-2 mt-16 px-4">
            {/* User (mobile) */}

            <li className="mt-4 flex justify-start ml-2">
              {isLoggedIn ? (
                <ul className="bg-base-100 shadow rounded-lg p-2 w-3/4">
                  <li className="flex mb-2 items-center relative">
                    <button
                      onClick={() =>
                        setIsMobileNotificationOpen((prev) => !prev)
                      }
                      className="relative"
                    >
                      <BellIcon className="w-6 h-6 text-gray-700" />

                      {notifications.filter((n) => n.isRead === "0").length >
                        0 && (
                        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full px-1">
                          {
                            notifications.filter((n) => n.isRead === "0")
                              .length
                          }
                        </span>
                      )}
                    </button>

                    {isMobileNotificationOpen && (
                      <div className="absolute left-0 top-8 bg-base-100 shadow-lg rounded-lg z-50 w-64 min-w-[200px] flex flex-col max-h-96 overflow-y-auto">
                        {notifications.filter((n) => n.isRead === "0")
                          .length === 0 ? (
                          <div className="text-gray-500 text-sm px-4 py-2">
                            Không có thông báo
                          </div>
                        ) : (
                          notifications

                            .filter((n) => n.isRead === "0")

                            .map((notification) => (
                              <Link
                                key={notification.id}
                                to={handleUrl(notification.data)}
                                onClick={() => {
                                  handleReadNotification(notification.id);

                                  dispatch(closeMobileMenu());

                                  setIsMobileNotificationOpen(false);
                                }}
                                className="block text-sm p-2 hover:bg-base-200"
                              >
                                <div className="flex justify-between items-center">
                                  <span>{notification.content}</span>

                                  {notification.isRead === "0" && (
                                    <span className="text-blue-500 text-xs">
                                      ⬤
                                    </span>
                                  )}
                                </div>
                              </Link>
                            ))
                        )}
                      </div>
                    )}
                  </li>

                  <li className="font-bold flex items-center gap-2 py-2">
                    <UserCircleIcon className="h-5 w-5 text-gray-600" />

                    <span className="truncate">{userFullName}</span>
                  </li>

                  <li>
                    <Link
                      to={"/admin"}
                      className="block py-2"
                      onClick={() => {
                        dispatch(closeMobileMenu());

                        setTimeout(() => {
                          window.location.reload();
                        }, 0);
                      }}
                    >
                      Trang quản trị
                    </Link>
                  </li>

                  <li>
                    <button
                      onClick={() => {
                        handleLogout();

                        dispatch(closeMobileMenu());
                      }}
                      className="block w-full py-2 text-left text-error"
                    >
                      Đăng xuất
                    </button>
                  </li>
                </ul>
              ) : (
                <div className="flex flex-col gap-2 bg-base-100 shadow rounded-lg p-2 w-3/4">
                  <Link
                    to="/login"
                    className="btn btn-ghost font-bold h-12 justify-start flex items-center gap-2"
                    onClick={() => {
                      dispatch(setCurrentPath("/login"));

                      dispatch(closeMobileMenu());
                    }}
                  >
                    Đăng nhập
                  </Link>
                </div>
              )}
            </li>

            {navItems.slice(1).map((item) => (
              <li key={item.path} className="relative">
                {item.subMenu?.length > 0 ? (
                  <>
                    <button
                      type="button"
                      className={`font-bold btn btn-ghost justify-between whitespace-nowrap h-12 ${
                        isActivePath(item.activePath || item.path)
                          ? "text-primary"
                          : "text-black"
                      }`}
                      onClick={() => {
                        navigate(item.path);

                        dispatch(setCurrentPath(item.path));

                        dispatch(closeMobileMenu());
                      }}
                    >
                      {item.label}
                    </button>

                    <ul className="pl-4">
                      {item.subMenu.map((subItem) => (
                        <li key={subItem.path}>
                          {subItem.onClick ? (
                            <button
                              type="button"
                              className="block py-2 w-full text-left"
                              onClick={() => {
                                subItem.onClick();

                                dispatch(setCurrentPath(subItem.path));

                                dispatch(closeMobileMenu());
                              }}
                            >
                              {subItem.label}
                            </button>
                          ) : (
                            <Link
                              to={subItem.path}
                              className="block py-2"
                              onClick={() => {
                                dispatch(setCurrentPath(subItem.path));

                                dispatch(closeMobileMenu());
                              }}
                            >
                              {subItem.label}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link
                    to={item.path}
                    className={`btn btn-ghost font-bold h-12 ${
                      isActivePath(item.path) ? "text-primary" : "text-black"
                    }`}
                    onClick={() => {
                      dispatch(setCurrentPath(item.path));

                      dispatch(closeMobileMenu());
                    }}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        {isMobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => dispatch(closeMobileMenu())}
          />
        )}
      </header>

      {/* Thanh tìm kiếm dưới header */}

      <SearchBar
        show={isSearchStickyPage || isShowSearch}
        isMemberSearchAllowed={isLoggedIn} // RULE 1: Chưa login -> không có "Hội viên"
        onSearch={({ keyword, type }) => {
          // RULE: Cho submit rỗng để hiển thị tất cả

          if (type === "hoi-vien") {
            navigate(`/danh-sach-hoi-vien/${keyword}`);
          } else if (type === "san-pham") {
            navigate(`/danh-sach-san-pham?s=${encodeURIComponent(keyword)}`);
          }
        }}
      />
    </>
  );
}